import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  validateText(text: string): boolean {
    return !(text == undefined ||
        text == null ||
        text == "" ||
        text.trim().length === 0);
  }

  public validateTextId(text: string): boolean {
      if (text == undefined || text == "" || text.trim().length === 0 ||
          text.trim() == "-1") {
          return false;
      }
      return true;
  }

  validId(value: number): boolean {
      if (value == undefined || value <= 0) {
          return false;
      }
      return true;
  }

  validateNumber(num: number) {
      return !(num == undefined || num == null);
  }

  validateTextAndNumber(text: string, id: number) {
      if (text == undefined || text == "" || text.trim().length == 0 ||
          id == undefined ||
          id == null) {
          return false;
      }
      return true;
  }

  validateList(list: any[]): boolean {
      if (list != undefined && list != null && list.length > 0) {
          return true;
      }
      return false;
  }

  validateMandatoryFields(form: FormGroup): FormGroup {
    if (form != null && form != undefined) {
        Object.keys(form.controls).forEach(key => {
            if (form.controls[key].value != ""
                && form.controls[key].value != undefined
                && !(form.controls[key].value instanceof Date)
                && !(typeof (form.controls[key].value) === "boolean")
                && !(typeof form.controls[key].value === 'number')
                && !(typeof form.controls[key].value === 'symbol')
                && !(form.controls[key].value instanceof FormArray)
                && !(form.controls[key].value.constructor instanceof FormGroup)
                && !(form.controls[key].value.constructor instanceof Array)) {
                form.controls[key].setValue(form.controls[key].value.trim());
                form.updateValueAndValidity();
            }
        });
    }
    return form;
  }

  preventKeyUp(event: KeyboardEvent) : boolean {
    let keycode : number = event.keyCode;
    if( keycode == 229 || (keycode <= 90 && keycode >= 65) ||(keycode <= 57 && keycode >= 46) || keycode === 8 ||(keycode <= 105 && keycode >= 96)){
        return true;
    }
    return false;
  }

}
